import React from 'react';
import PropTypes from 'prop-types';

export default (NotificationTemplate, NextTaskButton, CustomUrlButton, DefaultButton) => {
	function missionNotification(props) {
		const { notification } = props;
		const Button = notification.task().nextTask()
			? NextTaskButton
			: notification.task().nextCustomUrl()
			? CustomUrlButton
			: DefaultButton;

		return <NotificationTemplate {...props} button={Button} />;
	}

	missionNotification.propTypes = {
		notification: PropTypes.object,
	};

	return missionNotification;
};
